// @ts-nocheck

import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { downloadRequestWithToken, fetchRequest, initialFetchListParams } from './index';
import { convertDataToServer as convertDataToServerTalon, convertDataFromServer as convertDataFromServerTalon } from './bioTreatmentFacilityTalon';
export const convertDataToServer = bioTreatmentFacilityVolume => ({
  ...bioTreatmentFacilityVolume,
  talons:
  //$FlowFixMe
  bioTreatmentFacilityVolume?.talons?.map(convertDataFromServerTalon) ?? []
});
export const convertDataFromServer = bioTreatmentFacilityVolume => ({
  ...bioTreatmentFacilityVolume,
  talons:
  //$FlowFixMe
  bioTreatmentFacilityVolume?.talons?.map(convertDataFromServerTalon) ?? []
});
const baseUrl = 'bioTreatmentFacilityVolume';
const bioTreatmentFacilityVolume = new CommonApi(baseUrl, 'учет БОС', convertDataToServer, convertDataFromServer);
export default {
  ...bioTreatmentFacilityVolume
};
